import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCheck = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 16 12"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M15.625.22a1 1 0 0 1 .156 1.405l-8 10a1 1 0 0 1-1.421.143l-6-5a1 1 0 0 1 1.28-1.536l5.216 4.347L14.22.375A1 1 0 0 1 15.625.22"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCheck;
